import "./treeListView.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import TreeListGroupView from "./TreeListGroupView";

const renderGroups = (groups, onChange, onAdd) =>
  groups.map(g => <TreeListGroupView key={g.value} group={g} onChange={onChange} onAdd={onAdd} />);

const TreeListView = props => {
  return <div className="treeListView">{renderGroups(props.groups, props.onChange, props.onAdd)}</div>;
};

TreeListView.propTypes = {
  groups: PropTypeShapes.listOptionGroupList,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func
};

export default TreeListView;
